import React from 'react';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AccessibilityButton from '../components/AccessibilityButton';
import AccessibilityPanel from '../components/AccessibilityPanel';
import Recommendations from '../components/Recommendations';
import { useKeyboardShortcuts } from '../hooks/useKeyboardShortcuts';

const RecommendationsPage: React.FC = () => {
  const { user, token } = useAuth();

  // Activăm scurtăturile de tastatură pentru accesibilitate
  useKeyboardShortcuts();

  // Creăm un obiect user compatibil cu componenta Recommendations
  const userWithToken = user ? { ...user, token } : null;

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Header />
      
      {/* Spațiu pentru header-ul fix */}
      <div className="pt-24 md:pt-28"></div>
      
      <main className="flex-grow container mx-auto px-4 py-8">
        <Recommendations user={userWithToken} />
      </main>
      
      {/* Componente de accesibilitate */}
      <AccessibilityButton />
      <AccessibilityPanel />
      
      <Footer />
    </div>
  );
};

export default RecommendationsPage; 